<template>
  <v-card class="work-card" elevation="0">
    <v-card-title class="work-card-header">
      <div>
        <div class="work-card-title">Missing comments</div>
        <div class="work-card-subtitle">Applications without a recent follow-up note</div>
      </div>
      <v-chip color="primary" text-color="white" small>{{ unCommentCount }}</v-chip>
    </v-card-title>
    <v-divider />
    <v-card-text class="pa-0">
      <div>
        <div ref="pieContainer" class="chart-container"></div>
      </div>
      <div v-if="!unCommentLeads.length" class="empty-state">
        <v-icon color="success" size="34">mdi-check-circle-outline</v-icon>
        <div>All applications have comments</div>
      </div>
      <v-list v-else class="work-list">
        <template v-for="item in unCommentLeads">
          <v-list-item
            @click="profile(item)"
            :key="item.name"
            v-if="item.unCommentCountLeads !== 0"
          >
            <v-list-item-icon class="mr-3">
              <v-avatar color="#F1F8F2" size="36"><v-icon color="primary" size="19">mdi-message-alert-outline</v-icon></v-avatar>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">{{ item.fatherName }}</v-list-item-title>
              <v-list-item-subtitle
                ><span>Created </span
                ><span>{{
                  item.createdAt | moment("from", "now")
                }}</span></v-list-item-subtitle
              >
            </v-list-item-content>
            <v-list-item-action>
              <v-chip x-small outlined color="primary" class="text-capitalize">{{ item.LeadStudents[0].status }}</v-chip>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    unCommentCount: {
      type: Number,
      default: 0,
    },
    unCommentLeads: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  // mounted() {
  //   this.renderPie();
  // },
  watch: {
    unCommentLeads: {
      handler() {
        // this.renderPie();
        this.renderDoc();
      },
      deep: true,
    },
  },
  methods: {
    profile(lead) {
      this.$router.push({ path: `/applications/${lead.id}/profile` });
    },
    renderDoc() {
      // Build counts by status
      const statusCounts = {};

      this.unCommentLeads.forEach((lead) => {
        const status = lead.LeadStudents[0]?.status || "Unknown";
        if (!statusCounts[status]) {
          statusCounts[status] = 0;
        }
        statusCounts[status]++;
      });

      // Prepare pie data
      const pieData = Object.keys(statusCounts).map((status) => ({
        name: status,
        y: statusCounts[status],
      }));

      // Determine if data labels should be shown
      const showDataLabels = !this.$vuetify.breakpoint.xsOnly;

      Highcharts.chart(this.$refs.pieContainer, {
        credits: { enabled: false },
        chart: {
          type: "pie",
          backgroundColor: "transparent",
          height: 230,
        },
        title: { text: null },
        tooltip: {
          pointFormat: "<b>{point.y} leads</b> ({point.percentage:.1f}%)",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            innerSize: "68%",
            dataLabels: {
              enabled: showDataLabels,
              format: "{point.name}: <b>{point.y}</b>",
              style: { color: "#64748B", fontSize: "11px", textOutline: "none" },
            },
            showInLegend: false,
          },
        },
        colors: [
          "#2E7D32", "#43A047", "#66BB6A", "#81C784", "#A5D6A7", "#C8E6C9",
        ],
        series: [
          {
            name: "Applications",
            colorByPoint: true,
            data: pieData,
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.work-card { height: 100%; border: 1px solid #e5eaf1; border-radius: 14px !important; overflow: hidden; }
.work-card-header { display: flex; justify-content: space-between; padding: 20px 22px; }
.work-card-title { color: #253047; font-size: 16px; font-weight: 700; }
.work-card-subtitle { color: #8491a5; font-size: 12px; font-weight: 400; margin-top: 3px; }
.chart-container { width: 100%; height: 230px; }
.work-list { max-height: 300px; overflow: auto; border-top: 1px solid #edf0f5; padding: 5px 10px; }
.work-list .v-list-item { border-radius: 9px; margin: 3px 0; }
.empty-state { height: 180px; display: flex; flex-direction: column; gap: 10px; align-items: center; justify-content: center; color: #64748b; }
</style>
